export type { NativeTouchOrMouseEvent, ReactTouchOrMouseEvent, TouchOrMouseEvent } from './mouseTouchHelpers';
export { getEventClientCoords, isMouseEvent, isTouchEvent } from './mouseTouchHelpers';
